import Validator from '../../validator/validator.js';

export default angular.module('BaseClass.validatable.validaters.required', [Validator])
    .factory('required', function(BCValidator) {
        function required(value, instance, field) {
            if (value === undefined || value === null) return false;
            if (value.constructor.name === 'String')
                return !!(value && value.length || typeof value === 'object');
            return value !== undefined;
        }

        required.message = 'cannot be blank.';

        return new BCValidator(required, 'required');
    }).name;
